type ValidateFeeParams = {
  label: string;
  min?: number;
  max?: number;
};

export function getFeeValidation({
  label,
  min = 0,
  max = 100,
}: ValidateFeeParams) {
  return (value: string): boolean | string => {
    const numericValue = Number(value.replace(/,/g, ''));

    if (numericValue < min) {
      return `${label} must be greater than or equal to ${min}`;
    }

    if (numericValue > max) {
      return `${label} must be less than or equal to ${max}`;
    }

    return true;
  };
}
